export const CommissionRouting = [
    {
      path: "/project/commission/list",
      name: "project-commission-list",
      meta: { title: "人员提成" },
      notice: {  },
      component: () =>
        import(
          /* webpackChunkName: "project-commission" */ "@/views/project/commission/list/index.vue"),
    }
    
  ];
  